import React, { Component } from "react";
import { Row, Col, Container } from "reactstrap";
import SignUp from '../auth/SignUp'
import { connect } from "react-redux";
import { compose } from "redux";
import {Redirect} from 'react-router-dom'

class SignUpPage extends Component {
  render() {
    return (
      <>
      <Container>
        <Row className="justify-content-center align-items-center mt-5">
          <Col md="4">
              <SignUp />
          </Col>
        </Row>
      </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth,
  };
};


export default compose(connect(mapStateToProps))(SignUpPage);
